import * as actionTypes from '../constants/chatActionTypes'
export const newMessage = ({ id, authorId, customId, text, buttons,replies, title, imageUrl, timestamp }) => ({
	type: actionTypes.NEW_MESSAGE,
	payload: {
		id,
		authorId,
		customId,
		text,
		buttons,
		replies,
		title,
		imageUrl,
		timestamp,
	},
})

export const sendMessage = ({ text, post }) => ({
	type: actionTypes.SEND_MESSAGE,
	payload: {
		text,
		customId: String(Math.random()),
		timestamp: new Date(),
		post:post
	},
})

export const changeChatScreen = ({ screen }) => ({
	type: actionTypes.CHANGE_CHAT_SCREEN,
	payload: {
		screen
	}
})

export const savePreForm = ({name, email, mobile, message}) => ({
	type: actionTypes.SAVE_PRE_FORM,
	payload: {
		name,
		email,
		mobile,
		message,
	}
})

export const sendPreForm = ({name, email, mobile, message}) => ({
	type: actionTypes.SEND_PRE_FORM,
	payload: {
		name,
		email,
		mobile,
		message,
	}
})

export const sendPostForm = ({question1, question2, question3}) => ({
	type: actionTypes.SEND_POST_FORM,
	payload: {
		question1,
		question2,
		question3,
	}
})

export const updateNumberInQueue = ({numberInQueue}) => ({
	type: actionTypes.UPDATE_VISITOR_QUEUE,
	payload: {
		numberInQueue,
	}
})

export const newUser = ({ id, name, email, avatarUrl }) => ({
	type: actionTypes.NEW_USER,
	payload: {
		id,
		name,
		email,
		avatarUrl,
	},
})

export const ownDataReceived = ({ id }) => ({
	type: actionTypes.OWN_DATA_RECEIVED,
	payload: {
		id,
	},
})

export const chatEnded = () => ({
	type: actionTypes.CHAT_ENDED,
})

export const chatStarted = ({ chatId }) => ({
	type: actionTypes.CHAT_STARTED,
	payload: {
		chatId,
	},
})

export const changeChatService = ({ chatService }) => ({
	type: actionTypes.CHANGE_CHAT_SERVICE,
	payload: {
		chatService,
	},
})

export const rateGood = () => ({
	type: actionTypes.RATE_GOOD,
})

export const rateBad = () => ({
	type: actionTypes.RATE_BAD,
})

export const chatRated = ({ rate }) => ({
	type: actionTypes.CHAT_RATED,
	payload: {
		rate,
	},
})

export const closeChat = () => ({
	type: actionTypes.CLOSE_CHAT,
})

export const sendTranscript = ({ email }) => ({
	type: actionTypes.SEND_TRANSCRIPT,
	payload: {
		email,
	}
})


// WEBPACK FOOTER //
// ./src/actions/chatActions.js